import React, { useState } from "react";
import { pmndpAPI } from "../../../services/pmndp.api";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";

const UnbookAppointment = ({ onClose, patient_id, dialysis_id, slot_id, getDiaList }) => {
   
    const [isPageLoading, setIsPageLoading] = useState(false);
    const [unbookForm, setUnbookForm] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!unbookForm || !unbookForm.reason || !unbookForm.remarks) {
            alert("Please fill all required fields.");
            return;
        }

        const payload = {
            remarks: unbookForm.remarks,
            reason: unbookForm.reason,
            id: patient_id,
            slot_id: slot_id,
            dialysis_id: dialysis_id || "",
            is_public: unbookForm.is_public ? 1 : 0,
            is_declare: unbookForm.is_declare ? 1 : 0
        };

        setIsPageLoading(true);
        try {
            const resp = await pmndpAPI.unbookSlot(payload);

            if (resp && resp.success) {
                setIsPageLoading(false);
                toast.success(`Slot unbooked successfully.`);
                setTimeout(() => {
                    onClose();
                    getDiaList && getDiaList();
                }, 1200);
            } else {
                toast.error(resp?.msg || "Failed to unbook slot.", { className: "custom-toast-error" });
                setIsPageLoading(false);
            }
        } catch (error) {
            toast.error("Error while unbooking slot.", { className: "custom-toast-error" });
            setIsPageLoading(false);
        }
    };

    return (
        <>
            
            {isPageLoading && <Loader />}
            <div className="modal fade show d-block verificationModel addPatentModel" style={{ background: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <form onSubmit={handleSubmit}>
                            <div className="modal-header border-bottom-0">
                                <div className="text-center headerText">
                                    <h5 className="modal-title">Unbook Slot</h5>
                                </div>
                                <button type="button" className="btn-close" onClick={onClose} />
                            </div>
                            <div className="modal-body">
                                <div className="bookAnAppointMentModelBody">
                                    <div className="dialysisPatentDetails">
                                        <h4>Are you sure wants to unbook this slot ?</h4>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="control-label">
                                                    Reason<span style={{ color: "red" }}>*</span>
                                                </label>
                                                <select
                                                    className="form-control"
                                                    value={unbookForm?.reason || ""}
                                                    onChange={e =>
                                                        setUnbookForm(prev => ({
                                                            ...prev,
                                                            reason: e.target.value
                                                        }))
                                                    }
                                                    required
                                                >
                                                    <option value="">Select</option>
                                                    <option value="Death">Death</option>
                                                    <option value="Kidney Transplant">Kidney Transplant</option>
                                                    <option value="Drop Out">Drop Out</option>
                                                    <option value="Others">Others</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="control-label">
                                                    Remarks<span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Remarks"
                                                    value={unbookForm?.remarks || ""}
                                                    onChange={e =>
                                                        setUnbookForm(prev => ({
                                                            ...prev,
                                                            remarks: e.target.value
                                                        }))
                                                    }
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group form-inline mt-2">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input me-2"
                                                    id="declareVacant"
                                                    checked={unbookForm?.is_declare || false}
                                                    onChange={e =>
                                                        setUnbookForm(prev => ({
                                                            ...prev,
                                                            is_declare: e.target.checked
                                                        }))
                                                    }
                                                />
                                                <label className="form-check-label" htmlFor="declareVacant">
                                                    Declare as Vacant Slot
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group form-inline mt-2">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input me-2"
                                                    id="isPublic"
                                                    checked={unbookForm?.is_public || false}
                                                    onChange={e =>
                                                        setUnbookForm(prev => ({
                                                            ...prev,
                                                            is_public: e.target.checked
                                                        }))
                                                    }
                                                />
                                                <label className="form-check-label" htmlFor="isPublic">
                                                    Is publicly visible
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="cancel" onClick={onClose}>Cancel</button>
                                <button type="submit" className="submit">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default UnbookAppointment;
